'use client';

// this whole meta pixel topic had very bad documentation
// this is heavily AI coded
import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useCookieConsent } from '@/context/cookieConsentContext';
import { processMetaPixelQueue } from '@/lib/metaPixel';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}
export default function MetaPixelProvider() {
  const $ = _c(4);
  const {
    consentGiven,
    isMounted
  } = useCookieConsent();
  const timeoutRef = useRef(null);
  const attemptsRef = useRef(0);
  let t0;
  let t1;
  if ($[0] !== consentGiven || $[1] !== isMounted) {
    t0 = () => {
      const cleanup = () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        attemptsRef.current = 0;
      };
      if (!isMounted || typeof window === "undefined") {
        cleanup();
        return;
      }
      if (consentGiven === "accepted") {
        if (!process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID) {
          cleanup();
          return;
        }
        if (window.fbq) {
          window.fbq("init", process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID);
          window.fbq("track", "PageView");
          processMetaPixelQueue();
          cleanup();
        } else {
          const existingScript = document.getElementById("meta-pixel-js");
          if (existingScript) {
            if (window.fbq && typeof window.fbq === "function") {
              const fbq = window.fbq as (...args: unknown[]) => void;
              fbq("init", process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID);
              fbq("track", "PageView");
              processMetaPixelQueue();
              cleanup();
              return;
            }
            const monitorExistingScript = () => {
              if (window.fbq && typeof window.fbq === "function") {
                (window.fbq as (...args: unknown[]) => void)("init", process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID);
                (window.fbq as (...args: unknown[]) => void)("track", "PageView");
                processMetaPixelQueue();
                cleanup();
              } else {
                attemptsRef.current = attemptsRef.current + 1;
                if (attemptsRef.current >= 50) {
                  cleanup();
                  return;
                }
                timeoutRef.current = setTimeout(monitorExistingScript, 100);
              }
            };
            monitorExistingScript();
            return;
          }
          const loadMetaPixelScript = () => {
            const script = document.createElement("script");
            script.id = "meta-pixel-js";
            script.innerHTML = `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          `;
            document.head.appendChild(script);
            const waitForMetaPixel = () => {
              if (window.fbq) {
                window.fbq("init", process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID);
                window.fbq("track", "PageView");
                processMetaPixelQueue();
                cleanup();
              } else {
                attemptsRef.current = attemptsRef.current + 1;
                if (attemptsRef.current >= 50) {
                  cleanup();
                  return;
                }
                timeoutRef.current = setTimeout(waitForMetaPixel, 100);
              }
            };
            waitForMetaPixel();
          };
          loadMetaPixelScript();
        }
      } else {
        cleanup();
      }
      return cleanup;
    };
    t1 = [consentGiven, isMounted];
    $[0] = consentGiven;
    $[1] = isMounted;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}